/** Max rows returned for one expanded group. The group `count` is still the full total. */
export const PROJECT_OPEN_ITEM_LIST_LIMIT = 200;
export const PROJECT_OPEN_ITEM_GROUP_KEYS = [
    'pages-pending',
    'documents-pending',
    'reconstructed-documents-pending',
    'pages-error',
    'documents-error',
    'reconstructed-documents-error',
];
//# sourceMappingURL=api-projects-id-open-items.api.schema.js.map